import { useTranslation } from 'react-i18next';

import { useFormik } from 'formik';
// import { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
// @ts-ignore
import { use, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useLookupNationality from '@hooks/Lookups/use-Lookup-Nationality';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { cleanLocation, editLocation, getLocation, getLocations } from '@store/HR/HRSetting/locationSlice';
import { formLocation } from '../../../../ValidationForm/validationSchema';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardBody } from '@components/card/card';
// import Map from '@components/Shared/Map/Map';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Map2 from '@components/Shared/Map2/Map2';
import Loading from '@components/Shared/Loader/Loading';

// @ts-ignore
const EditLocation = props => {
  const { Id } = props;
  const { HasPermission } = usePermissions();
  const Navigate = useNavigate();
  const { Organizations } = useGetOrganizations();
  // @ts-ignore
  const dataOrg = Organizations?.filter(f => f.type === '130');
  const { NATIONALITY } = useLookupNationality();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  // @ts-ignore
  const { loading2, error2, Location } = useSelector(state => state.Locations);

  useEffect(() => {
    if (Id) {
      // @ts-ignore
      dispatch(getLocation(Id));
    }
    return () => {
      dispatch(cleanLocation());
    };
  }, [Id]);

  const formik = useFormik({
    initialValues: {
      name: Location ? Location.name : '',
      name2: Location ? Location.name2 : '',
      businessGroupId: Location ? Location.businessGroupId : '',
      description: Location ? Location.description : '',
      shipToLocationId: Location ? Location.shipToLocationId : '',
      shipToSiteFlag: Location ? Location.shipToSiteFlag : '',
      receivingSiteFlag: Location ? Location.receivingSiteFlag : '',
      billToSiteFlag: Location ? Location.billToSiteFlag : '',
      country: Location ? Location.country : '',
      addressLine: Location ? Location.addressLine : '',
      townOrCity: Location ? Location.townOrCity : '',
      postalCode: Location ? Location.postalCode : '',
      region: Location ? Location.region : '',
      telephoneNumber: Location ? Location.telephoneNumber : '',
      latitude: Location ? Location.latitude : '',
      longitude: Location ? Location.longitude : '',
      //-------------------
      center: {
        lat: Location?.latitude ? Number(Location.latitude) : 0,
        lng: Location?.longitude ? Number(Location.longitude) : 0
      }
    },

    enableReinitialize: true,
    validationSchema: formLocation(t),

    // @ts-ignore
    onSubmit: (values, { resetForm }) => {
      // values.latitude = lat.toString();
      // values.longitude = lng.toString();

      // @ts-ignore
      dispatch(
        // @ts-ignore
        editLocation({
          id: Location?.id,
          name: values.name,
          name2: values.name2,
          // businessGroupId: values.businessGroupId,
          businessGroupId: null,
          description: values.description,
          shipsToLocationId: null, /// نحتاجها في المبيعات
          shipToSiteFlag: null, // نحتاجها في المبيعات
          receivingSiteFlag: null, // نحتاجها في المبيعات
          billToSiteFlag: null, // نحتاجها في المبيعات
          country: values.country,
          addressLine: values.addressLine,
          townOrCity: values.townOrCity,
          postalCode: values.postalCode,
          region: values.region,
          telephoneNumber: values.telephoneNumber,
          latitude: String(values.latitude),
          longitude: String(values.longitude)
          // latitude: String(values.center.lat),
          // longitude: String(values.center.lng)
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Edit' });
          // Navigate(-1);
          document.getElementById('closeModalLocation')?.click();
          // @ts-ignore

          dispatch(getLocations());
        })
        // @ts-ignore
        .catch(error => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  return (
    <>
      <Loading loading={loading2} error={error2}>
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <div className='mb-4'>
              <h6 className=''>
                <i className='fa-solid fa-circle-info text-theme me-2'></i>
                المعلومات الأساسية
              </h6>
              <hr />

              <div className='row'>
                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('LocalName')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='name2'
                      onChange={formik.handleChange}
                      value={formik.values.name2 || ''}
                      isInvalid={formik.touched.name2 && formik.errors.name2}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('GlobalName')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='name'
                      onChange={formik.handleChange}
                      value={formik.values.name || ''}
                      isInvalid={formik.touched.name && formik.errors.name}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                  </div>
                </div>
                {/* <div className='col-xl-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Organization')}</label>
                      <Form.Select
                        className='form-select'
                        name='businessGroupId'
                        onChange={formik.handleChange}
                        value={formik.values.businessGroupId || ''}
                        isInvalid={formik.touched.businessGroupId && formik.errors.businessGroupId}
                      >
                        <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                        {Organizations &&
                          Organizations?.map((item, idx) => (
                            <option key={++idx} value={item.id}>
                              {i18n.language === 'ar' ? item.name2 : item.name}
                            </option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type='invalid'>
                        {formik.errors.businessGroupId}
                      </Form.Control.Feedback>
                    </div>
                  </div> */}
              </div>
            </div>
            <div className='mb-4'>
              <h6 className=''>
                <i className='fa-solid fa-address-book text-theme me-2'></i>
                العنوان ومعلومات الإتصـال
              </h6>
              <hr />

              <div className='row'>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Country')}</label>
                    <Form.Select
                      className='form-select'
                      name='country'
                      onChange={formik.handleChange}
                      value={formik.values.country || ''}
                      isInvalid={formik.touched.country && formik.errors.country}
                    >
                      <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {NATIONALITY?.map(
                        (
                          // @ts-ignore
                          item,
                          // @ts-ignore
                          idx
                        ) =>
                          // @ts-ignore
                          item.list?.map(list => (
                            <option key={++idx} value={list.lookupCode}>
                              {i18n.language === 'en' ? list.meaning : list.meaning2}
                            </option>
                          ))
                      )}
                    </Form.Select>
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('City')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='townOrCity'
                      onChange={formik.handleChange}
                      value={formik.values.townOrCity || ''}
                      isInvalid={formik.touched.townOrCity && formik.errors.townOrCity}
                    />
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Address')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='addressLine'
                      onChange={formik.handleChange}
                      value={formik.values.addressLine || ''}
                      isInvalid={formik.touched.addressLine && formik.errors.addressLine}
                    />
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PostalCode')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='postalCode'
                      onChange={formik.handleChange}
                      value={formik.values.postalCode || ''}
                      isInvalid={formik.touched.postalCode && formik.errors.postalCode}
                    />
                  </div>
                </div>

                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('MobileNumber')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='telephoneNumber'
                      onChange={formik.handleChange}
                      value={formik.values.telephoneNumber || ''}
                      isInvalid={formik.touched.telephoneNumber && formik.errors.telephoneNumber}
                    />
                  </div>
                </div>
                <div className='col-xl-9'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={formik.values.description || ''}
                    />

                    <div></div>
                  </div>
                </div>
              </div>
            </div>

            <div className='mb-4'>
              {/* Section Header */}
              <div className='d-flex align-items-center mb-3'>
                <i className='fas fa-map-marker-alt fa-lg me-2 text-theme'></i>
                <h6 className='m-0'>الموقع الجغرافي</h6>
              </div>
              <hr className='mt-1 mb-4' />

              {/* Coordinates Input */}
              <div className='row g-3 mb-3'>
                <div className='col-md-6'>
                  <div className='input-group flex-nowrap'>
                    <span className='input-group-text fw-bold'>{t('Longitude')}</span>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='longitudeInput'
                      value={formik.values.longitude || ''}
                      onChange={e => formik.setFieldValue('longitude', parseFloat(e.target.value))}
                      readOnly
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='input-group flex-nowrap'>
                    <span className='input-group-text fw-bold'>{t('Latitude')}</span>
                    <Form.Control
                      type='text'
                      className='form-control'
                      id='latitudeInput'
                      value={formik.values.latitude || ''}
                      onChange={e => formik.setFieldValue('latitude', parseFloat(e.target.value))}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Interactive Map */}
              <div className='border rounded p-2 mb-3' style={{ height: '250px' }}>
                <div className='h-100'>
                  <Map2
                    // center={{lat: 24.7135517, lng: 46.6752957}}
                    center={formik.values.center}
                    // center={center}
                    onMarkerMove={(newLat, newLng) => {
                      formik.setFieldValue('latitude', newLat);
                      formik.setFieldValue('longitude', newLng);
                    }}
                  />
                </div>
              </div>

              {/* Help Text */}
              <div className='text-muted small'>
                <i className='fas fa-info-circle me-2'></i>
                يمكنك تحديد الموقع إما عن طريق إدخال الإحداثيات أو النقر على الخريطة
              </div>
            </div>

            <hr />

            <div className='text-center'>
              {HasPermission('EditHrLocation') && (
                <button disabled={formik.isSubmitting} type='submit' className='btn me-1 btn-theme mb-1'>
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-save fa-lg fa-fw me-2'></i>
                  )}
                  {t('Save')}
                </button>
              )}
              <button
                id='closeModalLocation'
                type='button'
                className=' btn me-1 btn-default mb-1'
                data-bs-dismiss='modal'
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Form>
        </CardBody>
      </Loading>
    </>
  );
};

export default EditLocation;
